<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
<div>
  <div class="row">
    <div class="col-xl-6 col-md-6 col-sm-12">
      <div class="card bg-primary text-white">
        <div class="row">
          <div class="col-md-9">
            <div class="card-body">
              <div class="mb-3">
                <h3>{{ detailUser.nama_lengkap || "Nama Lengkap" }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <i
              style="    
                height: 40px;
                width: 40px;
                opacity: 0.8;
                float: right;
                margin-right: 13px;"
              class="c-sidebar-nav-icon fa fa-user opacity-7"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-md-6 col-sm-12">
      <div class="card bg-primary text-white">
        <div class="row">
          <div class="col-md-9">
            <div class="card-body">
              <div class="mb-3">
                <h3>{{ detailUser.nama_sertifikasi || "Nama Sertifikasi" }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <i
              style="    
                height: 40px;
                width: 40px;
                opacity: 0.8;
                float: right;
                margin-right: 13px;"
              class="c-sidebar-nav-icon fas fa-file-alt opacity-7"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Dokumen Peserta
      <Button
        class="btn btn-md btn-success ml-auto text-white "
        :disabled="cekDisable()"
        style="float:right;margin-right:10px"
        @click="prosesAdministrasi()">
          Proses Administrasi
      </Button>
      <Button
        class="btn btn-md btn-dark d-inline-block float-right text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
      
    </div>
    
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4 pr-sm-0">
         
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama File</th>
                      <th>Status Wajib</th>
                      <th>Status Verifikasi</th>
                      <th class="text-center" colspan="2">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value , index) in dokumenPeserta" v-bind:key="index">
                      <td>{{ index+1 }}</td>
                      <td
                        class="w-50 w-sm-100 text-uppercase"
                        style="text-align:left"
                      >
                        {{ value.namaDokumen }}
                      </td>                                         
                      <td 
                        class="font-weight-bold"
                        :class="{
                          'text-success': value.statusRequired == '1',
                          'text-danger': value.statusRequired == '0',
                        }"
                      >
                        {{ value.statusRequired == '1' ? 'Wajib' : 'Tidak Wajib' }}
                      </td>                                            
                      <td
                        class="font-weight-bold text-secondary"
                        v-if="value.statusUpload == '0'"
                      >Belum Upload</td>
                      <td
                        class="font-weight-bold text-success"
                        v-if="value.statusUpload == '1'"
                      >Terverifikasi</td>
                      <td
                        class="font-weight-bold text-primary"
                        v-if="value.statusUpload == '2'"
                      >Sudah Upload</td>
                      <td
                        class="font-weight-bold text-warning"
                        v-if="value.statusUpload == '3'"
                      >File Tidak Terbaca</td>
                      <td
                        class="font-weight-bold text-danger"
                        v-if="value.statusUpload == '4'"
                      >File Tidak Sesuai</td>
                      <td class="text-center">
                        <button
                          class="btn btn-warning text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0' "
                          v-c-tooltip="'Lihat File'"
                          @click="bukaFile(value.file)"
                        >
                          <small><i class="fa fa-eye"  ></i></small>
                        </button>
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-info text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0'"
                          v-c-tooltip="'Verifikasi'"
                          @click="verifikasiDokumen(value.idDokumenPendukungPeserta, value.statusUpload,value.alasan)"
                        >
                          <small><i class="fa fa-check"  ></i></small>
                        </button>
                      </td>
                      
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </CRow>

      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
              </select>
            </CCol>
            <CCol sm="12" v-if="formData.statusUpload != '1'">
              <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
              <textarea 
                class="form-control" 
                cols="30" 
                rows="4" 
                v-model="formData.alasan" 
                placeholder="Masukkan alasan">
              </textarea>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Dokumen</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</div>
</template>
<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";
import Utils from "../../../services/utils.service";
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service";

export default {
  name: "DataDokumen",
  el: "#app",
  data() {
    return {
      fileName: "Choose File",
      details: {},
      detailUser : {},
      masterDokumen: [],
      dokumenPeserta: [],
      statusVerifikasi : 0,
      formData: {
        idDokumenPendukungPeserta: "",
        statusUpload: "",
        alasan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      index: 0,
      content: []
    };
  },
  
  mounted() {
    
    this.getData();
    
    this.getDataSertifikasi(0,10,this.filter,this.$route.params.id_sertifikasi_peserta);
  },

  methods: {
    getDataSertifikasi(currentPage,pageSize,filter,idSertifikasiPeserta) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataPesertaService.getMataUjiPesertaSertifikasi(currentPage,pageSize,filter,idSertifikasiPeserta)
      .then(response => {    
        vm.detailUser = response.data.anotherData;        
        loader.hide();  
      }).catch(error => {
        // comment console console.log(error);
      })
    },

    cekDisable() {
      if(this.statusVerifikasi == 0) {
        return true;    
      } else {
        return false
      }
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    bukaFile(file) {
     
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        file,
        params
      );
    },

    updateDataAnggota() {
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {
          // comment console console.log(response);
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },

    alertProsess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Proses administrasi berhasil"
      });
    },

    verifikasiDokumen(idDokumenPendukungPeserta, statusUpload, alasan) {                  
      this.modalVerif = true;          
      this.formData.idDokumenPendukungPeserta = idDokumenPendukungPeserta;
      this.formData.statusUpload = statusUpload;
      this.formData.alasan = alasan
    },

    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;

      DataPesertaService.detailDataPeserta(
        this.$route.params.id_sertifikasi_peserta
      )
        .then(response => {                    
          vm.dokumenPeserta = response.data.singleData.data_dokumen;
          vm.statusVerifikasi = response.data.singleData.status_verifikasi;          
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });      
    },

    postData() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          loader.hide()
          this.modalVerif = false;
          this.alertVerif();
          vm.getData();
        })
        .catch(error => {
          loader.hide()
          // comment console console.log(error);
        });
    },

    prosesAdministrasi(){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var formData = {
        idSertifikasiPeserta : this.$route.params.id_sertifikasi_peserta,
        statusKelayakan : '1',
      }
      DataPesertaService.putSendProsesAdministrasiRpl(formData)
      .then(response => {
        // comment console console.log(response);
        loader.hide();
        this.alertProsess();
      }).catch(error => {
        loader.hide();
        this.alertError();
        // comment console console.log(error)
      })
    }

  }
};
</script>
